/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSticker,
  PodSection,
  PodSpacer,
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductRating,
  ProductATC
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';

export const IRGCustomProductPod = ({
  itemId, storeId, itemIndex, channel, irgSectionName
}) => {
  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{ parent: 'irg', irgSectionName, position: itemIndex }}
      render={(pod) => (
        <>
          <PodSticker position="top-left">
            <ProductBadge itemId={pod.itemId} storeId={storeId} />
          </PodSticker>
          <PodSticker position="top-right">
            <Favorite
              itemId={pod.itemId}
              storeId={storeId}
              showCircle
              showCount
            />
          </PodSticker>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
          />
          <PodSection columnAlign>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={3}
                // disableShopThisCollection
              />
            </PodSpacer>
            <ProductRating itemId={pod.itemId} />
            <Price
              channel={channel}
              itemId={pod.itemId}
              large={false}
              hideSavingsText={false}
              showPreferredPricingBadge
            />

            <ProductATC
              itemId={pod.itemId}
              showDisabledATC
              checkGeneric
              outline
            />
          </PodSection>
        </>
      )}
    />
  );
};

IRGCustomProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductRating,
  ProductHeader,
  Price,
  Favorite,
  ProductATC
);

IRGCustomProductPod.displayName = 'IRGCustomProductPod';